import { useCallback, useEffect } from 'react';

import { RewardRedemptionState } from '../models/RewardStore';
import { useRewardStore } from '../stores/RewardStore';

import useDoWhile, { DoWhileFn } from './useDoWhile';

const { fetchRedemption } = useRewardStore.getState();

const useLoadRedemption = (
  rewardOfferStore: string,
  rewardRedemptionId: string | undefined,
  setIsLoading: (isLoading: boolean) => void,
) => {
  const loadRedemption = useDoWhile(
    useCallback<DoWhileFn>(
      async (signal) => {
        if (rewardRedemptionId !== undefined) {
          const res = await fetchRedemption(
            rewardOfferStore,
            rewardRedemptionId,
            { signal },
          );
          if (res) {
            switch (res.state) {
              case RewardRedemptionState.Paying:
                {
                  const url = res.payment?.url;
                  if (url !== undefined) {
                    setIsLoading(false);
                    window.location.href = url;
                  }
                }
                return true;
              case RewardRedemptionState.Fulfilled:
                return true;
              case RewardRedemptionState.Failed:
                return false;
            }
          }
        }
        await new Promise((resolve) => setTimeout(resolve, 3000));
        return false;
      },
      [rewardOfferStore, rewardRedemptionId, setIsLoading],
    ),
  );

  useEffect(() => {
    if (rewardRedemptionId !== undefined) {
      loadRedemption().catch(() => {});
    }
  }, [loadRedemption, rewardRedemptionId]);
};

export default useLoadRedemption;
